import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class EducationGeneralService {
  constructor() {}

  openModel(modal: any, size: string, centered: boolean, modalService) {
    modalService.open(modal, { size: size, centered: false });
  }
}
